import React from 'react'
import { Box, Typography } from '@mui/material'
import type { SvgIconProps } from '@mui/material/SvgIcon'
import { darken } from '@mui/material/styles'
import { pixelToRemMap } from '@zuto/theme/src/mui/Typography'

export interface ActionTileProps {
  label: string
  icon: React.ElementType<SvgIconProps>
  href?: string
  bgColor?: string
  iconColor?: string
  onClick?: () => void
  target?: string
  rel?: string
}

const ActionTile: React.FC<ActionTileProps> = ({
  label,
  icon: Icon,
  href,
  bgColor,
  iconColor,
  onClick,
  target,
  rel
}) => {
  const isLink = Boolean(href)
  const OuterComponent = isLink ? 'a' : 'button'

  const baseBg = bgColor
  const hoverBg = bgColor && darken(bgColor, 0.06)

  const isInteractive = Boolean(onClick || href)

  return (
    <Box
      component={OuterComponent}
      href={href}
      onClick={onClick}
      target={target}
      rel={rel}
      sx={{
        width: '100%',
        textDecoration: 'none',
        boxSizing: 'border-box',
        border: 'none',
        background: 'transparent',
        p: 0,
        cursor: isInteractive ? 'pointer' : 'default'
      }}
    >
      <Box
        sx={{
          width: '100%',
          padding: '14px 18px',
          borderRadius: '16px',
          backgroundColor: baseBg,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxSizing: 'border-box',
          transition: 'background-color 0.15s ease',
          '&:hover': {
            backgroundColor: isInteractive ? hoverBg : undefined
          }
        }}
      >
        <Icon sx={{ fontSize: pixelToRemMap[22], color: iconColor }} />
        <Typography sx={{ mt: 2 }} variant="bodySmall">
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

export default ActionTile
